import { memo } from 'react';
import { IconProps } from './iconType';

export const MinusIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
      <rect x="4.25" y="10.4375" width="13.5" height="1.125" fill={color} />
    </svg>
  );
});

MinusIcon.displayName = 'MinusIcon';
